// What the EPO register tells about a PCT application, as the options of the form

const LANGUAGE_NAMES: Record<string, string> = {
  ar: "Arabic",
  zh: "Chinese",
  en: "English",
  fr: "French",
  de: "German",
  ja: "Japanese",
  ko: "Korean",
  pt: "Portuguese",
  ru: "Russian",
  es: "Spanish"
}

// "de" -> "German", only when the form offers that language
export function languageOption(code: string | null, options: string[]): string | null {
  const name = code ? LANGUAGE_NAMES[code] : undefined
  return name && options.includes(name) ? name : null
}

// "EP" -> "EP - European Patent Office", only when the form offers that office
export function authorityOption(code: string | null, options: string[]): string | null {
  return (code && options.find((option) => option.startsWith(`${code} - `))) || null
}

// "The date was filled in." / "The date and the ISA were filled in."
export function describeFilled(items: string[]): string {
  if (items.length === 0) return ""

  const list = items.length === 1 ? items[0] : `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`
  const sentence = `${list} ${items.length === 1 ? "was" : "were"} filled in.`

  return sentence.charAt(0).toUpperCase() + sentence.slice(1)
}
